import "./SelectGroupOptionComp.css";
import { defineComponent as s, inject as u, computed as a, openBlock as d, createBlock as c, unref as p, normalizeClass as r, withCtx as m, renderSlot as v } from "vue";
import { ButtonComp as f } from "./ButtonComp.js";
import { i as b } from "./isEqual.398c54af.js";
import { s as S } from "./selectGroupCompKey.5138b3ee.js";
import { _ as C } from "./_plugin-vue_export-helper.dad06003.js";
const _ = /* @__PURE__ */ s({
  __name: "SelectGroupOptionComp",
  props: {
    value: {
      type: Object,
      default: null
    }
  },
  setup(e) {
    const n = e, t = u(S, {
      handleSelection: () => ({}),
      parentValue: a(() => {
      })
    }), l = a(() => b(n.value, t.parentValue.value));
    return (i, o) => (d(), c(f, {
      onClick: o[0] || (o[0] = (G) => p(t).handleSelection(e.value)),
      class: r(["selectGroupOption", {
        "selectGroupOption--selected": l.value,
        "selectGroupOption--disabled": e.value.disabled
      }]),
      blank: "",
      id: e.value.id,
      "t-sel": e.value.tSel,
      disabled: e.value.disabled
    }, {
      default: m(() => [
        v(i.$slots, "default", { isSelected: l.value }, void 0, !0)
      ]),
      _: 3
    }, 8, ["class", "id", "t-sel", "disabled"]));
  }
});
const h = /* @__PURE__ */ C(_, [["__scopeId", "data-v-83f5bee6"]]);
export {
  h as SelectGroupOptionComp
};
//# sourceMappingURL=SelectGroupOptionComp.js.map
